import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "zysub_favorites";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

let state: string[] = readFavorites();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) {
      state = readFavorites();
      emit();
    }
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", onStorage);
  };
}

function getSnapshot() {
  return state;
}

function writeFavorites(next: string[]) {
  state = next;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // 忽略本地存储写入异常
  }
  emit();
}

export function toggleFavorite(id: string) {
  writeFavorites(state.includes(id) ? state.filter((item) => item !== id) : [...state, id]);
}

export function useFavorites() {
  const favorites = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);
  return { favorites, isFavorite, toggle: toggleFavorite };
}